import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  PATCH: 'STUDENT_COURSE_PATCH',
  PATCH_SUCCESS: 'STUDENT_COURSE_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENT_COURSE_PATCH_FAILURE',
  INVALIDATE_ITEM: 'STUDENT_COURSE_INVALIDATE_ITEM',
};

export const patch = actions.patch(
  studentCourseId => `${BASE_URL}/student-course/${studentCourseId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);

export const invalidateItem = params => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: { params },
  });
};
